import { IssueTemplateEditable } from '@/ui/DTO';
import { create, head, remove, update } from '@/services/api/resources/issueTemplate';

export const createIssueTemplates = async (templates: IssueTemplateEditable[]) => {
  const promises = [];
  const onlyCreatable = templates.filter(t => t.id === undefined);

  // eslint-disable-next-line no-restricted-syntax
  for (const issue of onlyCreatable) {
    promises.push(create(issue)());
  }

  return Promise.all(promises);
};

export const updateIssueTemplates = async (templates: IssueTemplateEditable[]) => {
  const promises = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const issue of templates) {
    // eslint-disable-next-line no-await-in-loop
    const response = await head(issue.id!)();
    promises.push(update(issue.id!, {
      // @ts-ignore
      version: (response.right as Response).headers.get('ETag'),
      data: issue,
    })());
  }

  return Promise.all(promises);
};

export const destroyIssueTemplates = async (templates: IssueTemplateEditable[]) => {
  const promises = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const issue of templates) {
    promises.push(remove(issue.id!)());
  }

  return Promise.all(promises);
};

export const handleIssueTemplates = async (templates: IssueTemplateEditable[]) => {
  const onlyToCreate = templates.filter(t => t.id === undefined);
  const onlyToUpdate = templates.filter(t => t.id && t.wasChanged);
  const onlyToDelete = templates.filter(t => t.id && t.softDeleted);
  const createIssueResponses = await createIssueTemplates(onlyToCreate);

  await destroyIssueTemplates(onlyToDelete);
  await updateIssueTemplates(onlyToUpdate);

  return {
    idsSync: [
      ...createIssueResponses.map(response => {
        // `createIssueResponses` returns `{right}`
        // but it's not typed to do so
        // @ts-ignore
        return response.right.id;
      }),
      ...templates.filter(t => t.id && !t.softDeleted).map(t => t.id),
    ],
  };
};
